import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { StatusOrcamentoEnum } from "core/features/orcamento/typings";

const { Option } = Select;

export interface SelectStatusOrcamentoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectStatusOrcamento({ value, ...rest }: SelectStatusOrcamentoProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option
        value={StatusOrcamentoEnum.PendenteAprovacao}
        key={StatusOrcamentoEnum.PendenteAprovacao}
      >
        Pendente de aprovação
      </Option>
      <Option
        value={StatusOrcamentoEnum.ConsultaFornecedor}
        key={StatusOrcamentoEnum.ConsultaFornecedor}
      >
        Em consulta com fornecedor
      </Option>
      <Option
        value={StatusOrcamentoEnum.Aprovado}
        key={StatusOrcamentoEnum.Aprovado}
      >
        Aprovado
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectStatusOrcamento;
